import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { type Team } from '@app/client';

type ReferralData = {
    referralCode?: string;
    inviteCode?: string;
    inviteTeam?: Team;
};
interface ReferralState extends ReferralData {
    setReferralcode: (code?: string) => void;
    setInviteTeam: (Team?: Team) => void;
    setInviteCode: (code?: string) => void;
    clearCode: () => void;
}

const initialState: ReferralData = {
    referralCode: undefined,
    inviteTeam: undefined,
    inviteCode: '',
};

export const useFantasyReferralStore = create<ReferralState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setReferralcode: (referralCode) => set({ referralCode }),
                setInviteCode: (inviteCode) => set({ inviteCode }),
                setInviteTeam: (inviteTeam) => set({ inviteTeam }),
                clearCode: () => set(initialState),
            }),
            { name: 'fantasy-referral-store' },
        ),
    ),
);

export async function generateSHA256Hash(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    const buffer = await crypto.subtle.digest('SHA-256', data);

    // Convert the buffer to a hexadecimal string
    const hashArray = Array.from(new Uint8Array(buffer));
    return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
